import { UserDTO, DepartmentDTO } from 'BaseDataTypes';

export interface EquipmentSimpleDTO {
  id: number;
  name: string;
}

export interface EquipmentBaseDTO extends EquipmentSimpleDTO {
  model?: string;
  series?: string;
  qrToken?: string;
  isServiceOK: number;
  usageNotice?: string;
  alarmRecipientEmail?: string;
  serviceFrequencyDelay?: number;
  serviceFrequencyMonths?: string;
  supplierName?: string;
  supplierPhone?: string;
  supplierAddress?: string;
  comment?: string;
  purchaseDate?: Date | string;
  bestbefore?: Date | string;
  departmentId?: number;
  locationId?: number;
  placement?: string;
  subCategoryId?: number;
  responsibleId?: number;
}

export interface EquipmentSummaryDTO extends EquipmentBaseDTO {
  subCategoryName: string;
  departmentName: string;
  lastServiceDate?: Date | string;
  nextServiceDate?: Date | string;
  hasBorrowHistory: boolean;
  locationName?: string;
  isBorrowedOrRented: boolean;
  responsibleName: string;
  projectNr?: string;
  qrUrl?: string;
}

export interface EquipmentDetailDTO extends EquipmentBaseDTO {
  categoryId?: number;
  categoryName?: string;
  createdById?: number;
  createdByName?: string;
  equipmentImage?: string;
  reminderDaysBeforeNextService?: number;
  qrImage?: string;
  isBorrowedOut?: boolean;
  currentBorrowId?: number;
  hasServiceHistory: boolean;
  hasBorrowHistory?: boolean;
  lastServiceDate?: Date | string;
  lastServicePerformedBy?: string;
  lastServiceStatusText?: string;
  lastServiceType?: string;
  lastServiceComment?: string;
  lastServiceColor?: string;
  lastBorrowDate?: Date | string;
  lastBorrowPersonInitials?: string;
  lastBorrowLocationName?: string;
  lastBorrowExpectedReturnDate?: Date | string;
  lastBorrowComment?: string;
  lastReturnDate?: Date | string;
  lastReturnStatus?: string;
  lastReturnComment?: string;
  guideLink?: string;
  equipmentBorrows?: EquipmentBorrowDetailDTO[];
  equipmentServices?: EquipmentServiceDetailDTO[];
}

export interface CategorySimpleDTO {
  id: number;
  name: string;
  order: number;
}

export interface CategorySummaryDTO extends CategorySimpleDTO {
  subCategories: SubCategorySimpleDTO[];
}

export interface CategoryDetailDTO extends CategorySimpleDTO {
  subCategoryIds: number[];
}

export interface EquipmentBorrowSimpleDTO {
  id: number;
  initials: string;
}

export interface EquipmentBorrowBaseDTO extends EquipmentBorrowSimpleDTO {
  borrowedDate?: Date;
  returnedDate?: Date;
  equipmentId: number;
}

export interface EquipmentBorrowSummaryDTO extends EquipmentBorrowDetailDTO {
  equipmentName?: string;
}

export interface EquipmentBorrowDetailDTO extends EquipmentBorrowBaseDTO {
  expectedReturnDate?: Date | string;
  borrowedComment?: string;
  returnedComment?: string;
  projectNr?: string;
  locationName?: string;
}

export interface EquipmentFileSimpleDTO {
  id: number;
  fileName: string;
}

export interface EquipmentFileSummaryDTO extends EquipmentFileSimpleDTO {
  equipmentName?: string;
}

export interface EquipmentFileDetailDTO extends EquipmentFileSimpleDTO {
  fileBlob: Uint8Array;
  equipmentId: number;
}

export interface EquipmentServiceSimpleDTO {
  id: number;
}

export interface EquipmentServiceBaseDTO extends EquipmentServiceSimpleDTO { }

export interface EquipmentServiceSummaryDTO extends EquipmentServiceBaseDTO {
  equipmentName?: string | null;
}

export interface EquipmentServiceDetailDTO extends EquipmentServiceBaseDTO {
  serviceBy: string;
  equipmentId: number;
  serviceDate: Date | null;
  serviceComment: string;
  serviceColor?: string | null;
  typeService?: boolean | null;
  typeCalibration?: boolean | null;
  typeRepair?: boolean | null;
  typeMalfunction?: boolean | null;
  typeVerification?: boolean | null;
}

export interface LocationSimpleDTO {
  id: number;
  name: string;
}

export interface LocationSummaryDTO extends LocationSimpleDTO { }

export interface LocationDetailDTO extends LocationSimpleDTO { }

export interface SubCategorySimpleDTO {
  id: number;
  name: string;
  categoryId: number;
}

export interface SubCategorySummaryDTO extends SubCategorySimpleDTO {
  comment?: string;
  order: number;
  categoryName?: string;
}

export interface SubCategoryDetailDTO extends SubCategorySimpleDTO { }

export enum IsServiceOkDTO {
  OK = 0,
  IkkeKontrolleret = 10,
  Defekt = 11
}
